import actions from 'actions';

const initialState = {
  notifications: [],
  loading: false,
  total: 0,
  canExtend: false,
  page: 1,
  limit: 20,
  trayOpen: false,
  reload: false,
};

function notifications(state = initialState, action) {
  switch (action.type) {
    case actions.notifications.NOTIFICATIONS_REQUESTED:
      return { ...state, loading: true };
    case actions.notifications.SET_RELOAD:
      return { ...state, reload: action.reload };
    case actions.notifications.REQUEST_EXTEND_NOTIFICATIONS:
      return { ...state, loading: true, page: state.page + 1 };
    case actions.notifications.EXTEND_NOTIFICATIONS:
      return {
        ...state, loading: false, total: action.total, notifications: [...state.notifications, ...action.notifications], canExtend: action.canExtend,
      };
    case actions.notifications.NOTIFICATIONS_RECEIVED:
      return {
        ...state, notifications: action.notifications, total: action.total, loading: false, canExtend: action.canExtend,
      };
    case actions.notifications.MARK_NOTIFICATIONS_AS_SEEN: {
      const { notifications: notificationsState } = state;
      const { notifications: notificationsSeen, markAllAsSeen } = action;
      const updatedNotifications = notificationsState.map((n) => {
        if (markAllAsSeen || (notificationsSeen.indexOf(n._id) > -1)) return { ...n, seen: true };
        return n;
      });
      return { ...state, notifications: updatedNotifications, total: 0 };
    }
    case actions.notifications.MARK_NOTIFICATION_AS_INTERACTED: {
      const { notifications: notificationsState } = state;
      const { notification } = action;
      const updatedNotifications = notificationsState.map((n) => {
        if (n._id === notification) return { ...n, interacted: true };
        return n;
      });
      return { ...state, notifications: updatedNotifications };
    }
    case actions.notifications.SET_TRAY_OPEN: {
      return { ...state, trayOpen: action.open };
    }
    default:
      return state;
  }
}

export default notifications;
